import { request } from "@/utils/request";

 
export function Add(params = {}) {
  return request({
    method: "post",
    url: "/adminApi/ContentWeb/AddFront",
    params,
  });
}
 
export function GetItemById(params = {}) {
  return request({
    method: "get",
    url: "/adminApi/ContentWeb/GetItemByIdFront",
    params,
  });
}

 
export function GetPage(params = {}) {
  return request({
    method: "get",
    url: "/adminApi/ContentWeb/GetPageFront",
    params,
  });
}
export function GetPageL(params = {}) {
  return request({
    method: "get",
    url: "/adminApi/ContentWeb/GetPageFrontL",
    params,
  });
}
 
export function GetSearch(params = {}) {
  return request({
    method: "get",
    url: "/adminApi/ContentWeb/GetSearchFront",
    params,
  });
}
 
export function AddCourseCollection(params = {}) {
  return request({
    method: "post",
    url: "/adminApi/ContentWeb/AddCourseCollection",
    params,
  });
}

export function GetCollectionState(params = {}) {
  return request({
    method: "get",
    url: "/adminApi/ContentWeb/GetCollectionState",
    params,
  });
}

export function GetCollectionList(params = {}) {
  return request({
    method: "get",
    url: "/adminApi/ContentWeb/GetCollectionList",
    params,
  });
}

//查看课程学员的收藏状态
export function GetCollectionSate(params = {}) {
  return request({
    method: "get",
    url: "/adminApi/ContentWeb/GetCollectionSate",
    params,
  });
}